/* eslint-disable jsx-a11y/alt-text */
import {motion} from 'framer-motion'
import {useEffect, useMemo, useRef} from 'react'
import {useAuth} from '../../authentication/AuthProvider'
import {usePatientContext} from './StyleDetailInformationWrapper'

import {ReactComponent as DuoCamera} from '../../../assets/icons/DuoCamera.svg'
import {ReactComponent as DuoChest} from '../../../assets/icons/DuoChest.svg'
import {ReactComponent as DuoMessage} from '../../../assets/icons/DuoMessage.svg'
import {ReactComponent as DuoSetting} from '../../../assets/icons/DuoSetting.svg'
import {ReactComponent as DuoUsersPlus} from '../../../assets/icons/DuoUsersPlus.svg'

import {Tag} from 'primereact/tag'
import {ReactComponent as DuoDoctorScope} from '../../../assets/icons/DuoDoctorScope.svg'
import {ReactComponent as DuoList} from '../../../assets/icons/DuoList.svg'
import {ReactComponent as DuoMale} from '../../../assets/icons/DuoMale.svg'
import {ReactComponent as DuoNotificationText} from '../../../assets/icons/DuoNotificationText.svg'
import {ReactComponent as DuoTemperature2} from '../../../assets/icons/DuoTemperature2.svg'
import {ReactComponent as DuoUserInfo} from '../../../assets/icons/DuoUserInfo.svg'
import {ReactComponent as HospitalIcon} from '../../../assets/icons/HospitalIcon.svg'
import {ReactComponent as HospitalNumberIcon} from '../../../assets/icons/HospitalNumberIcon.svg'
import {ReactComponent as NHSNumberIcon} from '../../../assets/icons/NHSNumberIcon.svg'
import defaultAvatar from '../../../assets/images/avatar.jpg'
import {capitalize} from '../../../utils/CommonUtils'

import {useQueryClient} from '@tanstack/react-query'
import moment from 'moment'
import {Avatar} from 'primereact/avatar'
import {Button} from 'primereact/button'
import {Divider} from 'primereact/divider'
import {SplitButton} from 'primereact/splitbutton'
import {Tooltip} from 'primereact/tooltip'
import {SystemRole} from '../../../Constants'
import {ReactComponent as MdSick} from '../../../assets/icons/DuoSick.svg'
import {useAppConfig} from '../../../context/app/AppContext'
import {useUserHospital} from '../../../context/hospital/UserHospitalContext'
import TranslateUtils from '../../../i18n/TranslateUtils'
import {QueryKeyTypes} from '../../../query-manager/QueryKeyTypes'
import {QueryKeyManager} from '../../../query-manager/QueryKeysManager'
import {getClientId} from '../../authentication/AuthUtils'
import BiometricsForm from '../../biometrics/BiometricsForm'
import SendMessageForm from '../../message/SendMessageForm'
import {isArrayAndNotEmpty} from '../../observations/Utils'
import {permissionOptionKeys} from '../../role/RoleConstant'
import SummaryTable from '../../summary/SummaryTable'
import StyledAssignmentHealthCarePractitioner from '../StyledAssignmentHealthCarePractitioner'
import StyledAssignmentPathway from '../StyledAssignmentPathway'
import StyledAssignmentStaticList from '../StyledAssignmentStaticList'
import StyledAssignmentSupportTeam from '../StyledAssignmentSupportTeam'
import '../styles.css'
import {
    getSupportTeamEventKey,
    supportTeamEvent,
    supportTeamEventTypes,
} from '../support-team/broadcast/SupportTeamEvent'
import StyledChangeAvatarForm from './StyledChangeAvatarForm'
import StyledPatientPortalSettingsForm from './StyledPatientPortalSettingsForm'
const iconStyle = {
    width: '18px',
    height: '18px',
    color: '#6c757d',
    marginRight: '6px',
}

const statusMapping = {
    normal: {severity: 'success', value: 'NORMAL'},
    mild: {severity: 'info', value: 'MILD'},
    moderate: {severity: 'warning', value: 'MODERATE'},
    severe: {severity: 'danger', value: 'SEVERE'},
}

const StyledBasicInformation = ({isFullScreen = false}) => {
    //#region Context
    const {currentViewedUser, handleCheckPermissionByKey} = usePatientContext()
    const {user} = useAuth()
    const {userRole} = useAppConfig()
    const {currentHospital} = useUserHospital()
    //#endregion
    //#region Translate
    const {
        translateKeys,
        translateCommons,
        translateDatatable,
        translateOptions,
    } = TranslateUtils()
    //#endregion
    const queryClient = useQueryClient()
    const changeAvatarRef = useRef(null)
    const biometricsRef = useRef(null)
    const hcpAssignmentRef = useRef(null)
    const staticListAssignmentRef = useRef(null)
    const pathwayAssignmentRef = useRef(null)
    const supportTeamRef = useRef(null)
    const summaryRef = useRef(null)
    const patientPortalSettingRef = useRef(null)
    const sendMessageRef = useRef(null)
    //#region Information
    const basicInformationList = useMemo(
        () => [
            {
                label: 'Gender',
                value: (
                    <div className="flex align-items-start">
                        {' '}
                        {currentViewedUser?.gender
                            ? currentViewedUser?.gender
                            : '-'}{' '}
                        <span>
                            {' '}
                            <DuoMale
                                className="text-blue-500"
                                height={16}
                                width={16}
                            />
                        </span>
                    </div>
                ),
                icon: <HospitalIcon />,
            },
            {
                label: 'Date of birth',
                value: currentViewedUser?.dob
                    ? `${currentViewedUser?.dob} ${
                          currentViewedUser?.age
                              ? `(${currentViewedUser?.age} y.o)`
                              : '-'
                      }`
                    : '-',
                // icon: <DobIcon />,
            },
            {
                label: 'Hospital Name',
                value: currentViewedUser?.hospitalName,
                icon: <HospitalIcon />,
            },
            {
                label: 'Hospital No',
                value: currentViewedUser?.hospitalNumber,
                icon: <HospitalNumberIcon />,
            },
            {
                label: 'NHS Number',
                value: currentViewedUser?.nhsNumber,
                icon: <HospitalIcon />,
            },

            {
                label: 'Arrival Date',
                value: currentViewedUser?.createdAt
                    ? moment(currentViewedUser?.createdAt).format(
                          'HH:mm DD-MM-YYYY ',
                      )
                    : '-',
                icon: <NHSNumberIcon />,
            },
            // {
            //     label: 'Discharge Date',
            //     value:
            //         currentViewedUser?.deletedAt &&
            //         currentViewedUser?.accountStatus === 'discharged'
            //             ? moment(currentViewedUser?.deletedAt).format(
            //                   'HH:mm DD-MM-YYYY ',
            //               )
            //             : '-',
            //     icon: 'pi pi-map-marker',
            //     col: 12,
            // },
            // {
            //     label: 'Emergency Contact',
            //     // value: currentViewedUser?.nhsNumber,
            //     col: 12,
            //     values: [
            //         {
            //             label: 'Name',
            //             value:
            //                 currentViewedUser?.emergencyContact?.fullName ||
            //                 '-',
            //         },
            //         {
            //             label: 'Phone',
            //             value:
            //                 currentViewedUser?.emergencyContact?.phone || '-',
            //         },
            //     ],
            //     icon: <HospitalIcon />,
            // },
        ],
        [currentViewedUser],
    )
    //#endregion

    //#region Menu - More Actions
    const items = [
        {
            label: (
                <span className="font-bold text-darkcyan">
                    Profile Settings
                </span>
            ),
            disabled: true,
        },
        {
            label: 'Change Avatar',
            icon: <DuoCamera style={iconStyle} />,
            visible: handleCheckPermissionByKey(
                permissionOptionKeys.allowToEdit,
            ),
            command: () => {
                changeAvatarRef.current.showForm()
            },
        },
        {
            label: 'Edit BMI',
            icon: <DuoChest style={iconStyle} />,
            visible: handleCheckPermissionByKey(
                permissionOptionKeys.allowToAddBiometrics,
            ),
            command: () => {
                biometricsRef.current.showForm(
                    currentViewedUser ? {...currentViewedUser?.biometrics} : {},
                )
            },
        },
        {
            separator: true,
        },
        {
            label: (
                <span className="font-bold text-darkcyan">
                    Patient Portal Settings
                </span>
            ),
            disabled: true,
        },
        {
            label: 'Change Setting',
            icon: <DuoSetting style={iconStyle} />,

            command: () => patientPortalSettingRef.current.showForm(),
        },
        {
            separator: true,
        },
        {
            label: <span className="font-bold text-darkcyan">Assignment</span>,
            disabled: true,
        },
        {
            label: 'Edit Support Team',
            icon: <DuoUsersPlus style={iconStyle} />,

            command: () => supportTeamRef.current.showForm(),
        },
        {
            label: 'Edit Pathway',
            icon: <DuoTemperature2 style={iconStyle} />,
            visible: handleCheckPermissionByKey(
                permissionOptionKeys.allowToAssignPathway,
            ),
            command: () => pathwayAssignmentRef.current.showForm(),
        },
        {
            label: 'Edit HC.Practitioner',
            icon: <DuoDoctorScope style={iconStyle} />,
            visible: handleCheckPermissionByKey(
                permissionOptionKeys.allowToAssignHcp,
            ),
            command: () => hcpAssignmentRef.current.showForm(),
        },
        {
            label: 'Edit Static List',
            icon: <DuoList style={iconStyle} />,
            visible: handleCheckPermissionByKey(
                permissionOptionKeys.allowToAssignStaticList,
            ),
            command: () => staticListAssignmentRef.current.showForm(),
        },
        {
            separator: true,
        },
        {
            label: <span className="font-bold text-darkcyan">Contact</span>,
            disabled: true,
        },
        {
            label: 'Send Message',
            icon: <DuoMessage style={iconStyle} />,
            command: () => sendMessageRef.current.showForm(currentViewedUser),
        },
    ]
    //#endregion

    //#region Event Listener on State Changes
    useEffect(() => {
        // USER SUPPORT TEAM CHANGE
        supportTeamEvent.on(
            getSupportTeamEventKey(
                supportTeamEventTypes.USER_SUPPORT_TEAM_CHANGE,
            ),
            data => {
                if (
                    !data ||
                    !data?.clientId ||
                    data?.clientId !== getClientId()
                ) {
                    return
                }

                if (
                    userRole === SystemRole.USER_WITH_ROLE &&
                    (!data?.hospitalId ||
                        data?.hospitalId !== currentHospital?.id)
                ) {
                    return
                }

                if (currentViewedUser?.id !== data?.userId) {
                    return
                }

                const {supportTeamKeys} = QueryKeyManager(
                    QueryKeyTypes.supportTeam,
                    user?.id,
                )

                queryClient.invalidateQueries({
                    queryKey: supportTeamKeys.pattern(),
                })
            },
        )
    }, [])

    const bmiStatus = useMemo(() => {
        let value = currentViewedUser?.biometrics?.bmi || 0
        if (value && value > 0) {
            if (value < 18.5) {
                return {
                    label: 'Thin',
                    background: 'rgb(244, 174, 149)',
                    color: 'var(--gray-800)',
                }
            } else if (18.5 <= value && value <= 22.9) {
                return {
                    label: 'Average',
                    background: '#44cc61',
                    color: 'white',
                }
            } else if (23.1 <= value && value <= 24.9) {
                return {
                    label: 'Over Weight',
                    background: '#fed070',
                    color: 'var(--gray-800)',
                }
            } else if (25 <= value && value <= 29.9) {
                return {
                    label: 'Obesity I',
                    background: '#fed070',
                    color: 'var(--gray-800)',
                }
            } else if (30 <= value && value <= 30.9) {
                return {
                    label: 'Obesity II',
                    background: 'rgb(244, 174, 149)',
                    color: 'var(--gray-800)',
                }
            } else if (30.9 <= value && value <= 40) {
                return {
                    label: 'Obesity III',
                    background: '#e74142',
                    color: 'white',
                }
            } else {
                return {
                    label: 'Obesity III +',
                    background: 'rgb(207, 66, 66)',
                    color: 'white',
                }
            }
        } else {
            return {
                label: '',
                background: '',
            }
        }
    }, [currentViewedUser?.biometrics?.bmi])

    return (
        <div className="w-full">
            {/* Patient Information */}
            <div className="relative h-full">
                <div className={`col-12`}>
                    <div
                        className={`flex flex-column justify-content-between align-items-center mb-3 `}>
                        {/* Avatar */}
                        <div className="">
                            <Avatar
                                className="basic-info-avatar"
                                image={
                                    currentViewedUser?.avatar
                                        ? currentViewedUser?.avatar
                                        : defaultAvatar
                                }
                                shape="circle"
                                alt="Avatar"
                                // style={{width: 120, height: 120}}
                            />
                        </div>

                        <div className="flex gap-1 align-items-center justify-content-between ">
                            {' '}
                            <h3 className="basic-info-name font-bold mb-1 text-center">
                                <span className="text-base text-600">
                                    {currentViewedUser?.title &&
                                    currentViewedUser.title !== 'unknown'
                                        ? `${capitalize(
                                              currentViewedUser?.title,
                                          )} `
                                        : ''}{' '}
                                </span>
                                <span className="">
                                    {' '}
                                    {currentViewedUser?.fullName
                                        ? capitalize(
                                              currentViewedUser?.fullName,
                                          )
                                        : '-'}
                                </span>
                            </h3>
                        </div>
                        <p className="font-semibold text-500 ">
                            {currentViewedUser?.email
                                ? currentViewedUser?.email
                                : '-'}
                        </p>
                    </div>
                </div>

                <div className="grid mb-3">
                    <div className="md:col-4 col-12">
                        <h6 className="font-bold text-600">Height</h6>
                        <div className="flex align-items-center justify-content-center h-8rem bg-gray-100 p-2 border-round">
                            <h4 className="text-black font-bold text-center">
                                {currentViewedUser?.biometrics?.height ? (
                                    <span>
                                        {currentViewedUser.biometrics.height}{' '}
                                        <br />
                                        <span className="text-sm text-500 uppercase">
                                            {currentViewedUser.biometrics
                                                .type === 'cmKg'
                                                ? 'cm'
                                                : 'inch'}
                                        </span>
                                    </span>
                                ) : (
                                    'N/A'
                                )}
                            </h4>
                        </div>
                    </div>
                    <div className="md:col-4 col-12">
                        <h6 className="font-bold text-600">Weight</h6>
                        <div className="flex align-items-center justify-content-center h-8rem bg-gray-100 p-2 border-round">
                            <h4 className="text-black font-bold text-center">
                                {currentViewedUser?.biometrics?.weight ? (
                                    <span>
                                        {currentViewedUser.biometrics.weight}{' '}
                                        <br />
                                        <span className="text-sm text-500 uppercase">
                                            {currentViewedUser.biometrics
                                                .type === 'cmKg'
                                                ? 'kg'
                                                : 'pound'}
                                        </span>
                                    </span>
                                ) : (
                                    'N/A'
                                )}
                            </h4>
                        </div>
                    </div>
                    <div className="md:col-4 col-12">
                        <h6 className="font-bold text-600">BMI</h6>
                        <div className="flex align-items-center justify-content-center h-8rem bg-gray-100 text-black font-bold p-2 border-round">
                            <h4 className="text-black font-bold">
                                {currentViewedUser?.biometrics?.bmi ? (
                                    <span>
                                        {currentViewedUser.biometrics.bmi}{' '}
                                        <br />
                                        <span
                                            className="text-sm text-500 uppercase"
                                            style={{color: bmiStatus?.color}}>
                                            {bmiStatus?.label
                                                ? bmiStatus.label
                                                : ''}
                                        </span>
                                    </span>
                                ) : (
                                    'N/A'
                                )}
                            </h4>
                        </div>
                    </div>
                </div>

                {/* <Biometrics /> */}
                <div className="flex gap-1 mb-4">
                    {' '}
                    <div className="col-6 m-0 p-0">
                        {' '}
                        {handleCheckPermissionByKey(
                            permissionOptionKeys.allowToViewSummary,
                        ) && (
                            <Button
                                className="text-sm bg-blue-50 hover:bg-blue-100 border-none text-blue-600 w-full h-3rem"
                                iconPos="left"
                                icon="pi pi-eye"
                                label={translateKeys('SUMMARY')}
                                onClick={() => summaryRef.current.showForm()}
                            />
                        )}{' '}
                    </div>{' '}
                    <SplitButton
                        menuClassName="custom-disability"
                        className="w-full h-3rem"
                        model={items}
                        severity="info"
                        // icon="pi pi-ellipsis-v"
                        label={translateKeys('ACTIONS')}
                    />
                </div>
                <div className="flex align-items-end gap-1 text-800 mb-3 px-1 ">
                    <DuoUserInfo
                        className="text-teal-700"
                        height={20}
                        width={20}
                    />
                    <h6 className="text-teal-700 font-bold m-0 p-0">
                        {translateKeys('General Information')}
                    </h6>
                </div>

                <div
                    className={`grid align-items-strecth styled-basic-info-wrapper col-12 m-0 p-0 mb-3 `}>
                    {basicInformationList?.map((item, index) => (
                        <div key={index} className="col-12 grid ">
                            <h5 className="col-5 text-base font-semibold text-600 m-0 p-0 ">
                                {item.label}:
                            </h5>
                            <h5 className="col-7 text-base m-0 p-0 capitalize">
                                {' '}
                                {item.value || '-'}
                            </h5>
                            {index !== basicInformationList.length - 1 && (
                                <Divider className="m-0 py-2" type="dashed" />
                            )}
                        </div>
                    ))}
                </div>
                <div className="mb-3">
                    <div className="flex align-items-end gap-1 text-800 mb-3 px-1 text-teal-700">
                        <DuoNotificationText
                            className=""
                            height={20}
                            width={20}
                        />
                        <h6 className="font-bold m-0 p-0">
                            {translateKeys('Emergency Contact')}
                        </h6>
                    </div>
                    <div className="col-12 grid ">
                        <h5 className="col-5 text-base font-semibold text-600 m-0 p-0 ">
                            Name:
                        </h5>
                        <h5 className="col-7 text-base m-0 p-0">
                            {' '}
                            {currentViewedUser?.emergencyContact?.fullName ||
                                '-'}
                        </h5>
                        <Divider className="m-0 py-2" type="dashed" />
                    </div>
                    <div className="col-12 grid ">
                        <h5 className="col-5 text-base font-semibold text-600 m-0 p-0 ">
                            Phone:
                        </h5>
                        <h5 className="col-7 text-base m-0 p-0">
                            {' '}
                            {currentViewedUser?.emergencyContact?.phone || '-'}
                        </h5>
                        <Divider className="m-0 py-2" type="dashed" />
                    </div>
                    <div className="col-12 grid ">
                        <h5 className="col-5 text-base font-semibold text-600 m-0 p-0 ">
                            Email:
                        </h5>
                        <h5 className="col-7 text-base m-0 p-0">
                            {' '}
                            {currentViewedUser?.emergencyContact?.email || '-'}
                        </h5>
                    </div>
                </div>

                <div className="flex align-items-end gap-1 text-800 mb-3 px-1 text-teal-700">
                    <MdSick style={{width: '20px', height: '20px'}} />{' '}
                    <h6 className=" font-bold m-0 p-0">
                        {translateKeys('Pathways')}
                    </h6>
                </div>
                <div className="col-12 flex justify-content-center">
                    {!!isArrayAndNotEmpty(currentViewedUser?.pathways) ? (
                        <div className="flex flex-grow-1 flex-wrap gap-2 ">
                            {currentViewedUser?.pathways.map((item, idx) => (
                                <div
                                    key={idx}
                                    id={`pathway-tooltip-${item.id}`}
                                    className="flex align-items-center justify-content-center p-2 border-round-lg hover:bg-gray-50 ">
                                    <img
                                        src={item.icon}
                                        height={40}
                                        width={40}
                                    />
                                    <Tooltip
                                        target={`#pathway-tooltip-${item.id}`}
                                        content={item.name}
                                        position="top"
                                    />
                                </div>
                            ))}
                        </div>
                    ) : (
                        ''
                    )}
                </div>

                {/* Summary Status */}
                {!!statusMapping[currentViewedUser?.sicknessStatus]
                    ?.severity && (
                    <motion.div
                        className="absolute top-0 left-0"
                        animate={{
                            opacity: [1, 0.6, 1],
                        }}
                        transition={{
                            repeat: Infinity,
                            duration: 1.5,
                            repeatType: 'loop',
                        }}>
                        <Tag
                            className="px-3"
                            severity={
                                statusMapping[currentViewedUser?.sicknessStatus]
                                    .severity
                            }
                            value={
                                statusMapping[currentViewedUser?.sicknessStatus]
                                    .value
                            }
                        />
                    </motion.div>
                )}
            </div>

            {/* Form Ref */}

            {/* Change Avatar Form */}
            <StyledChangeAvatarForm ref={changeAvatarRef} />

            {/* Biometric Form */}
            <BiometricsForm ref={biometricsRef} />

            {/* Assign Health Care Practitioner Form */}
            <StyledAssignmentHealthCarePractitioner
                userIds={!!currentViewedUser?.id ? [currentViewedUser?.id] : []}
                ref={hcpAssignmentRef}
            />

            {/* Assign Static List Form */}
            <StyledAssignmentStaticList
                userIds={!!currentViewedUser?.id ? [currentViewedUser?.id] : []}
                ref={staticListAssignmentRef}
            />

            {/* Assign Pathway Form */}
            <StyledAssignmentPathway
                userIds={!!currentViewedUser?.id ? [currentViewedUser?.id] : []}
                ref={pathwayAssignmentRef}
            />

            {/* Support Team Form */}
            <StyledAssignmentSupportTeam
                userIds={!!currentViewedUser?.id ? [currentViewedUser?.id] : []}
                ref={supportTeamRef}
            />

            {/* Summary Form */}
            <SummaryTable ref={summaryRef} />

            {/* Patient Portal Setting Form */}
            <StyledPatientPortalSettingsForm ref={patientPortalSettingRef} />

            {/* Message Form */}
            <SendMessageForm ref={sendMessageRef} />
        </div>
    )
}

export default StyledBasicInformation
